import { render, staticRenderFns } from "./AddPatientModal.vue?vue&type=template&id=d8f76468&scoped=true"
import script from "./AddPatientModal.vue?vue&type=script&lang=ts"
export * from "./AddPatientModal.vue?vue&type=script&lang=ts"
import style0 from "./AddPatientModal.vue?vue&type=style&index=0&id=d8f76468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f76468",
  null
  
)

export default component.exports